import axios from "axios";

/**
 * Texto que se le muestra al usuario ante un error del API de changelog.
 *
 * NestJS manda `message` como texto en los errores de negocio (por ejemplo el conflicto de versión
 * repetida) y como lista cuando falla la validación del DTO. Sin contemplar la lista se perdía el
 * detalle y quedaba un "Request failed with status code 400" que no le dice nada a nadie.
 */
export const mensajeDeError = (
  err: unknown,
  porDefecto = "Error inesperado",
): string => {
  if (axios.isAxiosError(err)) {
    const delServidor: unknown = err.response?.data?.message;

    if (typeof delServidor === "string" && delServidor.length > 0) {
      return delServidor;
    }

    if (Array.isArray(delServidor)) {
      const partes = delServidor.filter(
        (parte): parte is string =>
          typeof parte === "string" && parte.length > 0,
      );

      if (partes.length > 0) return partes.join(". ");
    }

    const status = err.response?.status;

    if (status && status >= 500) {
      return "Error del servidor. Intenta más tarde.";
    }

    return err.message || porDefecto;
  }

  return err instanceof Error ? err.message : porDefecto;
};
